import React from 'react';
import {Link} from 'react-router-dom';
import glasswaterLocks from '../images/glasswater-locks.jpg';
import greenQarter from '../images/green-quarter.jpg';
import highcroft from '../images/highcroft.jpg';
import snowhillWharf from '../images/snowhill-wharf.jpg';
import eastbrook from '../images/eastbrook.jpg';
import swansLanding from '../images/swans-landing.jpg';
import {LanguageContext} from '../LanguageContext';
import translation from '../translations.json';

import londonDock from '../images/londonDock.jpg';
import royalExchange from '../images/royalExchange.jpg';
import chelseaCreek from '../images/chelseaCreek.jpg';
import fulhamReach from '../images/fulhamReach.jpg';
import wandsworthMills from '../images/wandsworthMills.jpg';
import grandUnion from '../images/grandUnion.jpg';
import beaufortPark from '../images/beaufortPark.jpg';
import silkStream from '../images/silkStream.jpg';
import camdenGoodsYard from '../images/camdenGoodsYard.jpg';
import hertfordLocks from '../images/hertfordLocks.jpg';
import suttonGardenSquare from '../images/suttonGardenSqaure.jpg';

const SouthallSites = () => (
  <LanguageContext.Consumer>
    {({lang, changeLanguage}) => {
      return (
        <div className="flex flex-col text-center">
          <div className="bg-blue py-4">
            <h4 className="text-white text-2xl">{translation.site[lang.selected].SITE}</h4>
          </div>
          <Link to="/submission/greenQuarter">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={greenQarter} alt="greenQuarter" />
          </Link>
          <Link to="/submission/snowhillWharf">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={snowhillWharf} alt="snowhillWharf" />
          </Link>
          <Link to="/submission/eastbrook">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={eastbrook} alt="eastbrook" />
          </Link>
          <Link to="/submission/highcroft">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={highcroft} alt="highcroft" />
          </Link>
          <Link to="/submission/swansLanding">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={swansLanding} alt="swansLanding" />
          </Link>
          <Link to="/submission/glasswaterLocks">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={glasswaterLocks} alt="glasswaterLocks" />
          </Link>
          <Link to="/submission/londonDock">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={londonDock} alt="londonDock" />
          </Link>
          <Link to="/submission/royalExchange">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={royalExchange} alt="royalExchange" />
          </Link>
          <Link to="/submission/chelseaCreek">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={chelseaCreek} alt="chelseaCreek" />
          </Link>
          <Link to="/submission/fulhamReach">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={fulhamReach} alt="fulhamReach" />
          </Link>
          <Link to="/submission/wandsworthMills">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={wandsworthMills} alt="wandsworthMills" />
          </Link>
          <Link to="/submission/grandUnion">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={grandUnion} alt="grandUnion" />
          </Link>
          <Link to="/submission/beaufortPark">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={beaufortPark} alt="beaufortPark" />
          </Link>
          <Link to="/submission/silkStream">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={silkStream} alt="silkStream" />
          </Link>
          <Link to="/submission/camdenGoodsYard">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={camdenGoodsYard} alt="" />
          </Link>
          <Link to="/submission/hertfordLocks">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={hertfordLocks} alt="hertfordLocks" />
          </Link>
          <Link to="/submission/suttonGardenSquare">
            <img
              className="w-2/3 p-4 m-4 border-2 border-blue rounded"
              src={suttonGardenSquare}
              alt="suttonGardenSquare"
            />
          </Link>
        </div>
      );
    }}
  </LanguageContext.Consumer>
);

export default SouthallSites;



// WEBPACK FOOTER //
// ./src/components/SouthallSites.js